<template>
  <div>
    <div id="summaryPanel">
      <table id="summaryTable">
        <thead>
          <th>Producer Name</th>
          <th>Pay Period</th>
          <th>Producer Commissions</th>
          <th>Download Report</th>
        </thead>
        <tbody>
          <tr v-for="statement in statements" :key="statement.id">
            <td>
              <router-link
                :to="{
                  name: 'commission-overview.producer',
                  params: { year: $route.params.year, month: $route.params.month, producer: statement.producer.id },
                }"
              >
                {{ statement.producer.name }}
              </router-link>
            </td>
            <td>{{ toMonthName($route.params.month) }} {{ $route.params.year }}</td>
            <td>
              <table id="totalsTable">
                <tr>
                  <td>
                    Subtotal:
                  </td>
                  <td>${{ statement.subtotal.toFixed(2) }}</td>
                </tr>
                <tr v-for="bonus in statement.bonuses_and_fees" :key="bonus.id">
                  <td>{{ bonus.label }}:</td>
                  <td><span v-if="bonus.value < 0">-</span>${{ Math.abs(bonus.value).toFixed(2) }}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Total Commission:</strong>
                  </td>
                  <td>
                    <strong
                      ><span v-if="statement.total < 0">-</span>${{ Math.abs(statement.total).toFixed(2) }}</strong
                    >
                  </td>
                </tr>
              </table>
            </td>
            <td>
              <v-btn text icon @click="downloadProducerSummary(statement.producer.id)">
                <v-icon>{{ icons.mdiDownload }}</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mdiDownload } from '@mdi/js'
export default {
  data() {
    return {
      icons: {
        mdiDownload,
      },
      loading: {
        download: false,
      },
      statements: [],
    }
  },
  methods: {
    toMonthName(monthNumber) {
      const date = new Date()

      date.setFullYear(2023,parseInt(monthNumber) - 1,1);

      return date.toLocaleString('en-US', {
        month: 'long',
      })
    },
    loadSummary() {
      this.$api.commissionMonthlyReview.summary({ date: this.date }).then(({ data }) => {
        this.statements = data
      })
    },
    downloadProducerSummary(producerId) {
      if (this.loading.download) {
        return
      }

      this.loading.download = true

      this.$api.commissionStatements
        .export({
          date: this.date,
          user: producerId,
        })
        .then(({ data }) => {
          window.location = data.file
          setTimeout(() => {
            this.loading.download = false
          }, 1500)
        })
        .catch(() => {
          this.loading.download = false
        })
    },
  },
  mounted() {
    this.loadSummary()
  },
  computed: {
    date() {
      return this.$route.params.year + '-' + this.$route.params.month
    },
  },
  watch: {
    '$route.params': {
      handler: function() {
        this.loadSummary()
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped>
#summaryTable {
  width: 100%;
  border: none;

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #3a3541;

  thead {
    th {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 24px;
      text-transform: uppercase;
      color: #3a3541;
      text-align: left;
      padding: 16px 32px;
    }
  }

  tbody {
    tr {
      td {
        border: none;
        padding: 16px 32px;
        vertical-align: top;
      }
    }
  }
}

#totalsTable {
  width: 100%;
  max-width: 300px;
  td {
    border: none;
    padding: 0px 0px !important;
    vertical-align: top;
  }

  tr td:last-child {
    text-align: right;
  }
}
</style>
